import { inject } from "@angular/core";
import { PasswordResetService } from "@core/services/password-reset.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, switchMap, catchError } from "rxjs/operators";
import { forgotPasswordActions } from "./actions";
import {
  RequestResetPasswordCheckOTPDTO,
  RequestResetPasswordNewPasswordDTO,
} from "@core/models/forgot-password.interface";
import { of } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { ErrorDialogComponent } from "@shared/components/error-dialog/error-dialog.component";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";

export const requestResetPaswordOTPEffect = createEffect(
  (
    actions$ = inject(Actions),
    passwordResetService: PasswordResetService = inject(PasswordResetService),
  ) => {
    return actions$.pipe(
      ofType(forgotPasswordActions.requestResetPasswordOTP),
      switchMap(({ email }) => {
        return passwordResetService.requestOTP(email).pipe(
          map(() => {
            return forgotPasswordActions.requestResetPasswordOTPSuccess({
              email,
            });
          }),
          catchError((res: HttpErrorResponse) =>
            of(
              forgotPasswordActions.requestResetPasswordOTPFailed({
                code: res.status,
                message: res.error?.message ?? "An unexpected error occurred.",
              }),
            ),
          ),
        );
      }),
    );
  },
  { functional: true },
);

export const requestResetPaswordOTPEffectFailed = createEffect(
  (
    actions$ = inject(Actions),
    dialog = inject(MatDialog),
    router = inject(Router),
  ) => {
    return actions$.pipe(
      ofType(forgotPasswordActions.requestResetPasswordOTPFailed),
      map((data) => {
        if (data.code === 401 || data.code === 403) {
          router.navigate(["/auth/login"]);
        } else {
          dialog.open(ErrorDialogComponent, {
            data: {
              errorMessage: data.message,
            },
          });
        }
      }),
    );
  },

  { dispatch: false, functional: true },
);

export const resetPasswordCheckOTPEffect = createEffect(
  (
    actions$ = inject(Actions),
    passwordResetService: PasswordResetService = inject(PasswordResetService),
  ) => {
    return actions$.pipe(
      ofType(forgotPasswordActions.requestResetPasswordCheckOTP),
      switchMap((dto: RequestResetPasswordCheckOTPDTO) => {
        return passwordResetService
          .checkOTP({ email: dto.email, otp: dto.otp })
          .pipe(
            map((response) => {
              if (response.match) {
                return forgotPasswordActions.requestResetPasswordCheckOTPSuccess(
                  { otp: dto.otp },
                );
              } else {
                return forgotPasswordActions.requestResetPasswordCheckOTPFailed(
                  { message: "Invalid OTP" },
                );
              }
            }),
            catchError((res: HttpErrorResponse) =>
              of(
                forgotPasswordActions.requestResetPasswordCheckOTPFailed({
                  code: res.status,
                  message:
                    res.error?.message ?? "An unexpected error occurred.",
                }),
              ),
            ),
          );
      }),
    );
  },
  { functional: true },
);

export const resetPasswordCheckOTPEffectFailed = createEffect(
  (
    actions$ = inject(Actions),
    dialog = inject(MatDialog),
    router = inject(Router),
  ) => {
    return actions$.pipe(
      ofType(forgotPasswordActions.requestResetPasswordCheckOTPFailed),
      map((data) => {
        if (data.code === 401 || data.code === 403) {
          router.navigate(["/auth/login"]);
        } else {
          dialog.open(ErrorDialogComponent, {
            data: {
              errorMessage: data.message,
            },
          });
        }
      }),
    );
  },

  { dispatch: false, functional: true },
);

export const resetPasswordSendNewPasswordEffect = createEffect(
  (
    actions$ = inject(Actions),
    passwordResetService: PasswordResetService = inject(PasswordResetService),
  ) => {
    return actions$.pipe(
      ofType(forgotPasswordActions.requestSendNewPassword),
      switchMap((dto: RequestResetPasswordNewPasswordDTO) => {
        return passwordResetService
          .resetPassword({
            email: dto.email,
            otp: dto.otp,
            newPassword: dto.newPassword,
          })
          .pipe(
            map(() => forgotPasswordActions.requestSendNewPasswordSuccess()),
            catchError((res: HttpErrorResponse) =>
              of(
                forgotPasswordActions.requestSendNewPasswordFailed({
                  code: res.status,
                  message:
                    res.error?.message ?? "An unexpected error occurred.",
                }),
              ),
            ),
          );
      }),
    );
  },
  { functional: true },
);

export const resetPasswordSendNewPasswordEffectFailed = createEffect(
  (
    actions$ = inject(Actions),
    dialog = inject(MatDialog),
    router = inject(Router),
  ) => {
    return actions$.pipe(
      ofType(forgotPasswordActions.requestSendNewPasswordFailed),
      map((data) => {
        if (data.code === 401 || data.code === 403) {
          router.navigate(["/auth/login"]);
        } else {
          dialog.open(ErrorDialogComponent, {
            data: {
              errorMessage: data.message,
            },
          });
        }
      }),
    );
  },

  { dispatch: false, functional: true },
);
